// extracted by mini-css-extract-plugin
module.exports = {"container":"embedded-player_container__1B90G","wrapper":"embedded-player_wrapper__2n36G","thumbnail":"embedded-player_thumbnail__3owMU"};